<template>
  <div>
    <DatePicker />

  <el-row :gutter="10" >
      <NewSignups />
      <Videos />
      <BudgetAllocated />
  </el-row>
  <el-row :gutter="10" >
      <Campaigns />
      <Tracks />
      <BudgetSpent />
  </el-row>
  </div>
</template>

<script>

import NewSignups from '@/modules/admin/dashboard/components/NewSignups'
import Videos from '@/modules/admin/dashboard/components/Videos'
import Campaigns from '@/modules/admin/dashboard/components/Campaigns'
import Tracks from '@/modules/admin/dashboard/components/Tracks'
import BudgetAllocated from '@/modules/admin/dashboard/components/BudgetAllocated'
import BudgetSpent from '@/modules/admin/dashboard/components/BudgetSpent'
import DatePicker from '@/modules/admin/dashboard/components/DatePicker'
export default {
  components: {
    DatePicker,
    NewSignups,
    Videos,
    Campaigns,
    Tracks,
    BudgetAllocated,
    BudgetSpent
  }
}
</script>

<style lang="scss">
.statistic-graph {
  .el-card__body {
    height: 330px;
  }
  .card-header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &__title {
      display: flex;
      align-items: center;
    }

    &__filter {
      width: 150px;
      display: grid;
      justify-content: center;
    }
  }
}
</style>
